<template>
  <div>
    <div class="match-breakdown">
      <div class="match-breakdown__header">
        <div class="match-breakdown__header__row1">
          <div class="match-breakdown__header__row1__matchday" v-if="data && Object.keys(data).length > 0">
            {{ matchDayName }}
          </div>
          <div class="match-breakdown__header__row1__game">
            <div class="match-breakdown__header__row1__game__team">
              <img
                v-if="data && Object.keys(data).length > 0"
                :src="`https://golstatsimages.blob.core.windows.net/teams-80/${data.home_team}.png`"
              />
            </div>
            <div class="match-breakdown__header__row1__game__vsscore" v-if="data && Object.keys(data).length > 0">
              {{ data.score[0] }}-{{ data.score[1] }}
            </div>
            <div class="match-breakdown__header__row1__game__team">
              <img
                v-if="data && Object.keys(data).length > 0"
                :src="`https://golstatsimages.blob.core.windows.net/teams-80/${data.visiting_team}.png`"
              />
            </div>
          </div>
        </div>
        <div class="match-breakdown__header__sep"></div>
        <div class="match-breakdown__header__row2">
          <div class="match-breakdown__header__row2__date" v-if="data && Object.keys(data).length > 0">
            {{
              new Date(data.date_time_utc)
                .toLocaleDateString('es-ES', {
                  weekday: 'long',
                  month: 'long',
                  day: 'numeric',
                })
                .replace(',', '')[0]
                .toUpperCase() +
                new Date(data.date_time_utc)
                  .toLocaleDateString('es-ES', {
                    weekday: 'long',
                    month: 'long',
                    day: 'numeric',
                  })
                  .replace(',', '')
                  .substring(1)
            }}
            <span class="match-breakdown__header__row2__date__bold" v-if="data && Object.keys(data).length > 0">{{
              data.schedule.substring(0, data.schedule.length - 3)
            }}</span>
          </div>
        </div>
      </div>
      <div class="match-breakdown__table" v-if="data && Object.keys(data).length > 0">
        <div class="match-breakdown__table__row" :class="!isInfoVisible ? 'visiNone' : ''">
          <template v-if="type == 1">
            <div class="match-breakdown__table__row__title">Títular:</div>
            <div class="match-breakdown__table__row__value">
              <template v-if="matchs[data.game_id]">
                {{ matchs[data.game_id]['isTitular'] == 1 ? 'Si' : 'No' }}
              </template>
              <template v-else>0000</template>
            </div>
          </template>
          <template v-else>
            <div class="match-breakdown__table__row__title-min">Resultado:</div>
            <div class="match-breakdown__table__row__value-max">
              <template v-if="matchs[data.game_id]">
                {{
                  matchs[data.game_id]['result'] == 1
                    ? 'Ganado'
                    : matchs[data.game_id]['result'] == 2
                    ? 'Perdido'
                    : 'Empatado'
                }}
              </template>
              <template v-else>0000</template>
            </div>
          </template>
        </div>
        <div class="match-breakdown__table__sep" :class="!isInfoVisible ? 'visiNone' : ''"></div>
        <div class="match-breakdown__table__row" :class="!isInfoVisible ? 'visiNone' : ''">
          <template v-if="type == 1">
            <div class="match-breakdown__table__row__title">Minutos jugados:</div>
            <div class="match-breakdown__table__row__value">
              <template v-if="matchs[data.game_id]"> {{ matchs[data.game_id]['minutes'] }}</template>
              <template v-else>0000</template>
            </div>
          </template>
          <template v-else>
            <div class="match-breakdown__table__row__title">xG:</div>
            <div class="match-breakdown__table__row__value">
              <template v-if="matchs[data.game_id]"> {{ matchs[data.game_id]['xg'].toFixed(2) }}</template>
              <template v-else>0000</template>
            </div>
          </template>
        </div>
        <template v-if="position != 1">
          <div class="match-breakdown__table__sep" v-if="type == 1" :class="!isInfoVisible ? 'visiNone' : ''"></div>
        </template>
        <template v-else>
          <template v-if="!matchs[data.game_id]">
            <div class="match-breakdown__table__sep visiNone hola" v-if="type == 1"></div>
          </template>
        </template>
        <template v-if="position != 1">
          <div class="match-breakdown__table__row" v-if="type == 1" :class="!isInfoVisible ? 'visiNone' : ''">
            <div class="match-breakdown__table__row__title">Goles:</div>
            <div class="match-breakdown__table__row__value">
              <template v-if="matchs[data.game_id]">
                {{ matchs[data.game_id]['goals'] }}
              </template>
              <template v-else>0000</template>
            </div>
          </div>
        </template>
        <template v-else>
          <template v-if="!matchs[data.game_id]">
            <div class="match-breakdown__table__row visiNone hila4" v-if="type == 1">
              <div class="match-breakdown__table__row__title">Goles:</div>
              <div class="match-breakdown__table__row__value">
                <template v-if="matchs[data.game_id]">
                  {{ matchs[data.game_id]['goals'] }}
                </template>
                <template v-else>0000</template>
              </div>
            </div>
          </template>
        </template>
        <div class="match-breakdown__table__sep" v-if="type == 1" :class="!isInfoVisible ? 'visiNone' : ''"></div>
        <div class="match-breakdown__table__row" v-if="type == 1" :class="!isInfoVisible ? 'visiNone' : ''">
          <div class="match-breakdown__table__row__title">Tarjetas amarillas:</div>
          <div class="match-breakdown__table__row__value">
            <template v-if="matchs[data.game_id]">
              {{ matchs[data.game_id]['yellowcards'] }}
            </template>
            <template v-else>0000</template>
          </div>
        </div>
        <div class="match-breakdown__table__sep" v-if="type == 1" :class="!isInfoVisible ? 'visiNone' : ''"></div>
        <div class="match-breakdown__table__row" v-if="type == 1" :class="!isInfoVisible ? 'visiNone' : ''">
          <div class="match-breakdown__table__row__title">Tarjetas rojas:</div>
          <div class="match-breakdown__table__row__value">
            <template v-if="matchs[data.game_id]">
              {{ matchs[data.game_id]['redcards'] }}
            </template>
            <template v-else>-</template>
          </div>
        </div>
        <template v-if="matchs[data.game_id]">
          <template v-if="type == 1">
            <template v-for="(item, index) in matchs[data.game_id]['extra_categories']">
              <div :key="index" class="match-breakdown__table__sep" :class="!isInfoVisible ? 'visiNone' : ''"></div>
              <div class="match-breakdown__table__row" :class="!isInfoVisible ? 'visiNone' : ''">
                <div class="match-breakdown__table__row__title">{{ item.category_name }}:</div>
                <div class="match-breakdown__table__row__value">
                  <template v-if="item.category_name == 'xG '">{{ item.total.toFixed(2) }}</template
                  ><template v-else>{{ item.total }}</template>
                </div>
              </div>
            </template>
          </template>
          <template v-else>
            <template v-for="(item, index) in matchs[data.game_id]['extra_categories']">
              <div :key="index" class="match-breakdown__table__sep" :class="!isInfoVisible ? 'visiNone' : ''"></div>
              <div class="match-breakdown__table__row" :class="!isInfoVisible ? 'visiNone' : ''">
                <div class="match-breakdown__table__row__title">{{ item.category_name }}:</div>
                <div class="match-breakdown__table__row__value">
                  <template v-if="item.category_name == 'xG '">{{ item.total.toFixed(2) }}</template
                  ><template v-else>{{ item.total }}</template>
                </div>
              </div>
            </template>
          </template>
        </template>
        <template v-else>
          <template v-if="type == 1">
            <div class="match-breakdown__table__sep" :class="!isInfoVisible ? 'visiNone' : ''"></div>
            <div class="match-breakdown__table__row" :class="!isInfoVisible ? 'visiNone' : ''">
              <div class="match-breakdown__table__row__title">Tiros a gol:</div>
              <div class="match-breakdown__table__row__value">0</div>
            </div>
            <div class="match-breakdown__table__sep" :class="!isInfoVisible ? 'visiNone' : ''"></div>
            <div class="match-breakdown__table__row" :class="!isInfoVisible ? 'visiNone' : ''">
              <div class="match-breakdown__table__row__title">Cabeceos en área rival :</div>
              <div class="match-breakdown__table__row__value">0</div>
            </div>
            <div class="match-breakdown__table__sep" :class="!isInfoVisible ? 'visiNone' : ''"></div>
            <div class="match-breakdown__table__row" :class="!isInfoVisible ? 'visiNone' : ''">
              <div class="match-breakdown__table__row__title">Xg:</div>
              <div class="match-breakdown__table__row__value">0</div>
            </div>
          </template>
          <template v-else>
            <div class="match-breakdown__table__sep" :class="!isInfoVisible ? 'visiNone' : ''"></div>
            <div class="match-breakdown__table__row" :class="!isInfoVisible ? 'visiNone' : ''">
              <div class="match-breakdown__table__row__title">Tiros a gol:</div>
              <div class="match-breakdown__table__row__value">0</div>
            </div>
            <div class="match-breakdown__table__sep" :class="!isInfoVisible ? 'visiNone' : ''"></div>
            <div class="match-breakdown__table__row" :class="!isInfoVisible ? 'visiNone' : ''">
              <div class="match-breakdown__table__row__title">Cabeceos en área rival :</div>
              <div class="match-breakdown__table__row__value">0</div>
            </div>
            <div class="match-breakdown__table__sep" :class="!isInfoVisible ? 'visiNone' : ''"></div>
            <div class="match-breakdown__table__row" :class="!isInfoVisible ? 'visiNone' : ''">
              <div class="match-breakdown__table__row__title">Xg:</div>
              <div class="match-breakdown__table__row__value">0</div>
            </div>
            <div class="match-breakdown__table__sep" :class="!isInfoVisible ? 'visiNone' : ''"></div>
            <div class="match-breakdown__table__row" :class="!isInfoVisible ? 'visiNone' : ''">
              <div class="match-breakdown__table__row__title">Xg:</div>
              <div class="match-breakdown__table__row__value">0</div>
            </div>
            <div class="match-breakdown__table__sep" :class="!isInfoVisible ? 'visiNone' : ''"></div>
            <div class="match-breakdown__table__row" :class="!isInfoVisible ? 'visiNone' : ''">
              <div class="match-breakdown__table__row__title">Xg:</div>
              <div class="match-breakdown__table__row__value">0</div>
            </div>
            <div class="match-breakdown__table__sep" :class="!isInfoVisible ? 'visiNone' : ''"></div>
            <div class="match-breakdown__table__row" :class="!isInfoVisible ? 'visiNone' : ''">
              <div class="match-breakdown__table__row__title">Xg:</div>
              <div class="match-breakdown__table__row__value">0</div>
            </div>
          </template>
        </template>

        <div v-if="data.hasStats !== 1" class="match-breakdown__table__noresults">
          <template v-if="data.game_status !== 4">
            <div class="match-breakdown__table__noresults__icon">
              <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icon_ball_match.png" />
            </div>
            <div class="match-breakdown__table__noresults__title">{{ getText(data).title }}</div>
            <div class="match-breakdown__table__noresults__subtitle">{{ getText(data).subtitle }}</div>
          </template>
          <template v-else>
            <div class="match-breakdown__table__noresults__icon">
              <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icon_ball_match.png" />
            </div>
            <div class="match-breakdown__table__noresults__title">Partido pr&oacute;ximo</div>
            <div class="match-breakdown__table__noresults__subtitle">a jugarse</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { regularLeague, cup, cupLegacy } from '@/utils/play-off-abbreviations';

export default {
  name: 'SummaryMatchContainer',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    matchs: {
      type: Array,
      default: () => [],
    },
    position: {
      type: Number,
      default: 1,
    },
    type: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    ...mapGetters('filterGeneral', {
      seasonId: 'getSeasonId',
      isCup: 'isCup',
    }),
    isInfoVisible() {
      return this.matchs[this.data.game_id] && this.data.game_status !== 4 && this.data.hasStats === 1;
    },
    matchDayName() {
      let matchDayName = '';
      const roundNumberString = this.data.matchday_abbreviation.replace('M', '');
      const defaultName = `Jornada ${roundNumberString}`;
      if (this.isCup) {
        if (this.seasonId === 881) {
          matchDayName = cupLegacy[roundNumberString] || defaultName;
        } else {
          matchDayName = cup[this.data.matchday_abbreviation] || defaultName;
        }
      } else {
        if (this.data.season && this.data.season.type === 2) {
          if (this.data.matchday_id === 182) {
            matchDayName = 'PI1';
          } else if (this.data.matchday_id === 183) {
            matchDayName = 'PI2';
          } else if (this.data.matchday_id === 18) {
            matchDayName = 'Repechaje';
          }
        } else {
          matchDayName = regularLeague[this.data.matchday_abbreviation] || defaultName;
        }
      }
      return matchDayName;
    },
  },
  methods: {
    getText(game) {
      return {
        title:
          game.hasStats === 2 || (!this.matchs[this.data.game_id] && game.game_status === 1)
            ? 'No tuvo actividad'
            : 'Partido en proceso',
        subtitle:
          game.hasStats === 2 || (!this.matchs[this.data.game_id] && game.game_status === 1)
            ? 'en este partido'
            : 'de captura',
      };
    },
  },
};
</script>

<style scoped lang="scss">
.visiNone {
  visibility: hidden;
}
.match-breakdown {
  width: calc(100%);
  height: auto;
  // padding-left: 0.751vw;
  // padding-right: 0.751vw;
  display: block;
  @media screen and (max-width: 500px) {
    padding-left: 0.001vw;
    padding-right: 0.001vw;
  }
  &__header {
    width: 100%;
    height: 6.201vw;
    border-radius: 4.8px;
    display: inline-block;
    background-color: #132839;
    @media screen and (max-width: 1200px) {
      height: 6.601vw;
    }
    @media screen and (max-width: 1000px) {
      height: 7.601vw;
    }
    @media screen and (max-width: 768px) {
      height: 15.201vw;
    }
    @media screen and (max-width: 500px) {
      height: 28.201vw;
    }
    &__row1 {
      // background: red;
      width: 100%;
      height: 3.678vw;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      align-content: center;
      @media screen and (max-width: 768px) {
        height: 8.478vw;
      }
      @media screen and (max-width: 500px) {
        display: inline-block;
        height: 16.678vw;
      }
      &__matchday {
        width: 55%;
        // background: blue;
        height: 1.682vw;
        line-height: 1.682vw;
        font-family: 'Roboto-Black';
        font-size: 1.2vw;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: -0.13px;
        text-align: left;
        padding-left: 10px;
        color: #cbee6b;
        @media screen and (max-width: 1268px) {
          font-size: 1.15vw;
        }
        @media screen and (max-width: 768px) {
          height: 6.478vw;
          line-height: 6.478vw;
          font-size: 3vw;
        }
        @media screen and (max-width: 500px) {
          height: 7.478vw;
          line-height: 7.478vw;
          width: 100%;
          text-align: center;
          font-size: 4.854vw;
          letter-spacing: 0px;
        }
      }
      &__game {
        width: 45%;
        // background: greenyellow;
        height: 1.682vw;
        line-height: 1.682vw;
        @media screen and (max-width: 768px) {
          height: 6.478vw;
        }
        @media screen and (max-width: 500px) {
          height: 9.27vw;
          width: 40%;
        }
        display: inline-flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        &__team {
          width: 28%;
          height: 1.682vw;
          @media screen and (max-width: 768px) {
            height: 6.478vw;
          }
          @media screen and (max-width: 500px) {
            height: 8vw;
          }
          // background: rgb(128, 92, 3);
          display: inline-flex;
          justify-content: center;
          align-items: center;
          align-content: center;
          img {
            width: 2.102vw;
            @media screen and (max-width: 768px) {
              width: 4.502vw;
            }
            @media screen and (max-width: 500px) {
              width: 6.502vw;
            }
          }
        }
        &__vsscore {
          width: 33%;
          height: 1.682vw;

          // background: goldenrod;
          font-family: 'Roboto-Black';
          font-size: 1.009vw;
          font-weight: 900;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.682vw;
          letter-spacing: -0.11px;
          text-align: center;
          color: #cbee6b;
          @media screen and (max-width: 768px) {
            height: 6.478vw;
            line-height: 6.978vw;
            font-size: 2.622vw;
          }
          @media screen and (max-width: 500px) {
            height: 8vw;
            line-height: 8.754vw;
            font-size: 4.622vw;
          }
        }
      }
    }
    &__sep {
      width: 86%;
      height: 1px;
      background-color: #2c506c;
      margin: 0 auto;
    }
    &__row2 {
      width: 100%;
      height: 2.627vw;
      // background: palevioletred;
      @media screen and (max-width: 1200px) {
        height: 2.927vw;
      }
      @media screen and (max-width: 1000px) {
        height: 3.801vw;
      }

      margin-top: -3px;
      align-content: center;
      display: inline-flex;
      justify-content: space-between;
      &__date {
        height: 2.627vw;
        text-transform: capitalize;
        // background: cyan;
        width: 100%;
        font-family: 'Roboto-Regular';
        font-size: 0.81vw;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 2.627vw;
        letter-spacing: -0.19px;
        text-align: center;
        color: #cbee6b;
        @media screen and (max-width: 1200px) {
          height: 2.927vw;
          font-size: 0.987vw;
          line-height: 2.927vw;
        }
        @media screen and (max-width: 1000px) {
          height: 3.801vw;
          font-size: 1.287vw;
          line-height: 3.801vw;
        }
        @media screen and (max-width: 768px) {
          height: 5.927vw;
          font-size: 2.287vw;
          line-height: 5.927vw;
        }
        @media screen and (max-width: 500px) {
          height: 10.927vw;
          font-size: 3.987vw;
          line-height: 10.927vw;
        }
        &__bold {
          font-weight: bold;
          font-size: 0.83vw;
          padding-left: 0.525vw;
          @media screen and (max-width: 1200px) {
            font-size: 0.987vw;
          }
          @media screen and (max-width: 1000px) {
            font-size: 1.287vw;
          }
          @media screen and (max-width: 768px) {
            font-size: 2.287vw;
          }
          @media screen and (max-width: 500px) {
            font-size: 3.987vw;
          }
        }
      }
    }
  }
  &__table {
    width: 100%;
    position: relative;
    height: auto;
    border-radius: 9.6px;
    border: solid 0.5px #c4c7cb;
    background-color: #fff;
    margin-top: 0.526vw;
    display: inline-block;
    &__noresults {
      width: 100%;
      height: auto;
      position: absolute;
      margin-top: 4.344vw;
      &__icon {
        img {
          width: 4.52vw;
          @media screen and (max-width: 1200px) {
            width: 5.82vw;
            margin-top: 1.644vw;
          }
          @media screen and (max-width: 768px) {
            width: 10.52vw;
            margin-top: 6.644vw;
          }
          @media screen and (max-width: 500px) {
            width: 21.52vw;
            margin-top: 14.644vw;
          }
        }
      }
      &__title {
        width: 100%;
        height: auto;
        font-family: 'Roboto-Bold';
        font-size: 1.24vw;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: -0.26px;
        text-align: center;
        color: #b5b8ba;
        margin-top: 1.414vw;
        @media screen and (max-width: 1200px) {
          font-size: 1.9vw;
        }
        @media screen and (max-width: 768px) {
          font-size: 3.84vw;
        }
        @media screen and (max-width: 500px) {
          font-size: 6.24vw;
        }
      }
      &__subtitle {
        width: 100%;
        height: auto;
        font-family: 'Roboto-Regular';
        font-size: 0.974vw;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: -0.26px;
        text-align: center;
        color: #b5b8ba;
        margin-top: 0.214vw;
        @media screen and (max-width: 1200px) {
          font-size: 1.3vw;
        }
        @media screen and (max-width: 768px) {
          font-size: 2.7vw;
        }
        @media screen and (max-width: 500px) {
          font-size: 4.44vw;
        }
      }
    }
    &__row {
      width: 100%;
      height: auto;
      float: left;
      margin-top: 0.552vw;
      margin-bottom: 0.552vw;
      @media screen and (max-width: 1200px) {
        margin-top: 0.752vw;
        margin-bottom: 0.752vw;
      }
      @media screen and (max-width: 768px) {
        margin-top: 0.952vw;
        margin-bottom: 0.952vw;
      }
      @media screen and (max-width: 500px) {
        margin-top: 1.552vw;
        margin-bottom: 1.552vw;
      }
      display: inline-flex;
      justify-content: space-between;
      &__title-min {
        width: 50%;
        height: auto;
        // background: blueviolet;
        float: left;
        font-family: 'Roboto-Regular';
        font-size: 0.739vw;
        @media screen and (max-width: 1200px) {
          font-size: 1.128vw;
        }
        @media screen and (max-width: 768px) {
          font-size: 2.128vw;
        }
        @media screen and (max-width: 500px) {
          font-size: 3.828vw;
        }
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: auto;
        padding-left: 11px;
        letter-spacing: -0.17px;
        text-align: left;
        color: #727a80;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      &__title {
        width: 80%;
        height: auto;
        // background: blueviolet;
        float: left;
        font-family: 'Roboto-Regular';
        font-size: 0.739vw;
        @media screen and (max-width: 1200px) {
          font-size: 1.128vw;
        }
        @media screen and (max-width: 768px) {
          font-size: 2.128vw;
        }
        @media screen and (max-width: 500px) {
          font-size: 3.828vw;
        }
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: auto;
        padding-left: 11px;
        letter-spacing: -0.17px;
        text-align: left;
        color: #727a80;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      &__value-max {
        width: 50%;
        float: right;
        height: auto;
        font-family: 'Roboto-Black';
        font-size: 0.839vw;
        @media screen and (max-width: 1200px) {
          font-size: 1.168vw;
          padding-right: 0.5292vw;
        }
        @media screen and (max-width: 768px) {
          font-size: 2.128vw;
          padding-right: 1.5292vw;
        }
        @media screen and (max-width: 500px) {
          font-size: 3.828vw;
          padding-right: 2.8vw;
        }
        font-weight: 900;
        font-stretch: normal;
        // background: palevioletred;
        font-style: normal;
        line-height: auto;
        padding-right: 0.422vw;
        letter-spacing: -0.1px;
        text-align: right;
        color: #132839;
      }
      &__value {
        width: 20%;
        float: right;
        height: auto;
        font-family: 'Roboto-Black';
        font-size: 0.839vw;
        @media screen and (max-width: 1200px) {
          font-size: 1.168vw;
        }
        @media screen and (max-width: 768px) {
          font-size: 2.128vw;
        }
        @media screen and (max-width: 500px) {
          font-size: 3.828vw;
        }
        font-weight: 900;
        font-stretch: normal;
        // background: palevioletred;
        font-style: normal;
        line-height: auto;
        letter-spacing: -0.1px;
        text-align: center;
        color: #132839;
      }
    }
    &__sep {
      width: 94%;
      height: 1px;
      border-bottom: 1px dotted #a2aab7;
      margin-left: 3%;
      float: left;
    }
  }
}
</style>
